import { useState } from 'react';
import Modal from 'react-modal';
import QrCodeComponent from '../../components/common/QrCodeComponent';
import MgpButton from '../../elements/MgpButton/MgpButton';
import { v4 as uuidv4 } from 'uuid';
import { handleKeyDown } from '../../utils/utils';

type QrCodeModalProps = {
    isOpen?: boolean;
    onShowQrCode?: () => void;
    onCloseModal: () => void;
    onEventMessage?: (message: any, type: string) => void;
    docCode: string;
    docId?: string;
    handleSwitchUploadFromComputer?: () => void
};

export default function QrCodeModal({isOpen = true, onShowQrCode, onCloseModal, onEventMessage, docCode, docId, handleSwitchUploadFromComputer}: QrCodeModalProps) { 

    Modal.setAppElement("#root");

    const [showQrCode, setShowQrCode] = useState(false);

    const onShowQrCodeAction = () => {
        setShowQrCode(true);
        if(onShowQrCode) {
            onShowQrCode();
        }
        
    }


    const onCloseModalAction = () => {
        setShowQrCode(false);
        onCloseModal();
    }

    const onSwitch = () => {
        setShowQrCode(false);
        if (handleSwitchUploadFromComputer) {
            handleSwitchUploadFromComputer();
        }
    }
    
    return(
        <Modal isOpen={isOpen} onRequestClose={onCloseModalAction}>
            <div className="modale open">
                <div className="modale--content">
                <div className="modale--content--template">
                    <div className="modale--main-width-entreprise shadow-bleu pb-lg bg-glace ">
                        <form className="">
                            <div className="grid-flex va-center">
                                <div className="col-flex-4 sub-grid">
                                {!showQrCode&&
                                    <div className='wrapper-cta-inline m-y-lg'>
                                        <MgpButton size='small' color='bleu' text='Afficher le QR Code' onClick={onShowQrCodeAction}/>
                                    </div>
                                }
                                {showQrCode&&<QrCodeComponent onEventMessage={onEventMessage} docCode={docCode} eventId={uuidv4()} docId={docId} onTimeoutMessage={() => setShowQrCode(false)} />}
                                </div>
                                <div className='col-flex-6 sub-grid'>
                                    <p className='fw-medium fz-lg bleu mt-lg '>Télécharger vos documents depuis votre smartphone </p><br/>
                                    <span className="border-fushia light"></span>
                                
                                    <p className='mt-lg mr-xl text m-y-sm'>Pour télécharger ce document depuis votre smartphone, veuillez afficher le QR Code et suivre les étapes ci-dessous:</p>
                                    <ul className="list-digit-bleu mr-xl mt-lg">
                                        <li>Depuis votre smartphone, ouvrez l'application « QR Code » (Android) ou « Appareil photo » (Iphone).</li>
                                        <li>Dirigez l'appareil vers le code et le faire apparaître au centre de l'écran.</li>
                                        <li>Appuyez sur la bannière qui s'affiche.</li>
                                        <li>Suivez les instructions à l'écran de votre smartphone.</li>
                                    </ul>
                                    <p className='mt-lg'>Votre document va être téléchargé et transféré automatiquement ici.</p>
                                    {handleSwitchUploadFromComputer && <p className='mt-sm' onClick={onSwitch} role='button' tabIndex={0} onKeyDown={(e) => handleKeyDown(e)}>Changez d'avis ? <span className='link'>Cliquez ici</span> pour choisir et télécharger vos documents depuis votre ordinateur.</p>}
                                   
                                    <a className='cta-inline-bleu mt-xl' onClick={onCloseModalAction} role='button' tabIndex={0} onKeyDown={(e) => handleKeyDown(e)}>Annuler</a>   
                                </div>
                            </div>
                            
                        </form>
                        
                    </div>
                </div>
                </div>
            </div>
        </Modal>
    )
}